module.exports = __webpack_public_path__ + "Uplay+_colours.pdf";